export default __webpack_public_path__ + "static/media/anders.3ee7237a.jpg";